import { FC } from "react";
import Modal from "../../Modal";
import styles from "./Disconnect.module.scss";
import ModalContent from "../../Modal/ModalContent";
import cn from "classnames";
import { useTonConnectUI } from "@tonconnect/ui-react";
import { useNavigate } from "react-router-dom";
import { useWallet } from "@stores/wallet.store";

interface Props {
    isVisible: boolean;
    setIsVisible(isViisble: boolean): void;
}

const Disconnect: FC<Props> = ({ isVisible, setIsVisible }) => {
    const [tonConnectUI] = useTonConnectUI();
    const setAuth = useWallet((state) => state.setAuth);
    const setWallets = useWallet((state) => state.setWallets);
    const navigate = useNavigate();
    const close = () => setIsVisible(false);
    async function disconnectWallet() {
        try {
            await tonConnectUI.disconnect();
        } catch (error) {
        } finally {
            setAuth(false, "");
            setWallets([]);
            navigate("/");
            close();
        }
    }

    return (
        <Modal isVisible={isVisible} setIsVisible={setIsVisible}>
            <ModalContent classNames={styles.content}>
                <div className={styles.header}>
                    <h2 className={styles.headline}>Disconnect master wallet</h2>
                    <button className={styles.close} onClick={close}>
                        <picture>
                            <source
                                srcSet="/images/modal/closemobile.svg"
                                width={7.5}
                                height={7.5}
                                media="(max-width: 768px)"
                            />
                            <img
                                height={12}
                                width={12}
                                src="/images/modal/close.svg"
                                style={{ opacity: 0.4 }}
                                alt="Close modal"
                            />
                        </picture>
                    </button>
                </div>
                <p className={styles.description}>
                    This wallet is a master wallet, if you delete it, you will not be able to use the purchased
                    subscription. You will be able to connect this wallet again later
                </p>
                <div className={styles.buttons}>
                    <button onClick={close} className={cn(styles.button, styles.cancel)}>
                        Cancel
                    </button>
                    <button className={cn(styles.button, styles.disconnect)} onClick={disconnectWallet}>
                        Disconnect
                    </button>
                </div>
            </ModalContent>
        </Modal>
    );
};

export default Disconnect;
